import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {
	HEADER_ELEMENT_DEFAULT_INPUT,
	HeaderElementInput,
	HeaderElementInputSizes
} from 'shared/lib/struct-elements/header-element/header-element-input';

@Component({
	selector: 'shared-header-element',
	template: `
		<ng-container [ngSwitch]="size">
			<h1 *ngSwitchCase="sizes.h1"><ng-container *ngTemplateOutlet="content"></ng-container></h1>
			<h2 *ngSwitchCase="sizes.h2"><ng-container *ngTemplateOutlet="content"></ng-container></h2>
			<h3 *ngSwitchCase="sizes.h3"><ng-container *ngTemplateOutlet="content"></ng-container></h3>
			<h4 *ngSwitchCase="sizes.h4"><ng-container *ngTemplateOutlet="content"></ng-container></h4>
			<h5 *ngSwitchCase="sizes.label"><ng-container *ngTemplateOutlet="content"></ng-container></h5>
		</ng-container>
		<ng-template #content>
			<span>
				{{ label }}
				<sup *ngIf="description">
					<button class="btn btn-sm mr--3 shadow-none" (click)="showDescription = !showDescription"><i class="fa fa-question"></i></button>
				</sup>
			</span>
		</ng-template>
		<p *ngIf="showDescription">{{ description }}</p>
	`,
	styleUrls: ['./header-element.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderElementComponent implements HeaderElementInput, AfterViewInit {
	@Input() set input(input: HeaderElementInput) {
		const {description, dry, size, label} = Object.assign({}, HEADER_ELEMENT_DEFAULT_INPUT, input || {});
		this.description = description;
		this.label = label;
		this.dry = dry;
		this.size = size;
	}

	description: string;
	showDescription = false;
	dry: boolean;
	label: string;
	size: HeaderElementInputSizes;
	sizes = HeaderElementInputSizes;

	constructor(private cdr: ChangeDetectorRef) {}
	ngAfterViewInit(): void {
		if (this.dry && !this.description) this.cdr.detach();
	}
}
